import { render, staticRenderFns } from "./FaqDetails.vue?vue&type=template&id=835f6a0a&scoped=true"
import script from "./FaqDetails.vue?vue&type=script&lang=js"
export * from "./FaqDetails.vue?vue&type=script&lang=js"
import style0 from "./FaqDetails.vue?vue&type=style&index=0&id=835f6a0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835f6a0a",
  null
  
)

export default component.exports